import styled from 'styled-components'
import media from '../../../utils/responsiveBreakpoints'
import { Asset } from 'contentful'

export const BannerContainer = styled.div`
  background-color: #f4f4f7;
`

export const BannerWrapper = styled.div<{ image?: Asset['fields'] }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: static;
  margin-bottom: 2rem;
  ${(props) => (props.image ? 'min-height: auto' : `min-height: 320px;  margin-bottom: 0;`)};

  ${(props) => ({
    ...media.from('md').css({
      marginBottom: 0,
      minHeight: props.image ? 'auto' : '400px',
    }),
  })}
`

export const TextWrapper = styled.div<{ hasImage: boolean }>`
  position: 'static';
  mx: auto;
  z-index: 2;
  width: 100%;
  ${{
    ...media.from('md').css({
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: (props) => (props?.hasImage ? '65%' : '100%'),
    }),
  }}
`
